
import type { Client } from "@/types";

export type Note = {
  date: string;
  content: string;
};

export type ActivityNotes = Note[] | string | null | undefined;

/**
 * Check if notes exist as an array and have content
 */
export const hasArrayNotes = (notes: ActivityNotes): notes is Note[] => {
  return Boolean(notes && Array.isArray(notes) && notes.length > 0);
};

/**
 * Check if notes exist as a string with content
 */
export const hasStringNotes = (notes: ActivityNotes): notes is string => {
  return Boolean(notes && typeof notes === 'string' && notes.trim() !== '');
};

/**
 * Determine if we have any valid activity data
 */
export const hasActivityData = (notes: ActivityNotes): boolean => {
  return hasArrayNotes(notes) || hasStringNotes(notes);
};
